import { useOrgScopedLocalStorage } from 'src/hooks/useOrgScopedLocalStorage';

import { SECTION_IDS } from '../constants';
import type { StoredPreferences } from '../types';

export const RISK_OVERVIEW_PANEL_PREFERENCES_KEY =
  'RiskOverviewPanel-Preferences';

export const DEFAULT_RISK_OVERVIEW_PANEL_PREFERENCES: StoredPreferences = {
  sections: [
    { id: SECTION_IDS.inherent, enabled: true },
    { id: SECTION_IDS.residual, enabled: true },
  ],
};

export const useRiskOverviewPanelPreferences = () => {
  const [preferences, setPreferences] =
    useOrgScopedLocalStorage<StoredPreferences>(
      DEFAULT_RISK_OVERVIEW_PANEL_PREFERENCES,
      { localStorageKey: RISK_OVERVIEW_PANEL_PREFERENCES_KEY }
    );

  return { preferences, setPreferences };
};
